import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { MEDIA } from '@brg/ui'

export const TEST_ATTEMPT_FEEDBACK_GREEN = '#29894e'
export const TEST_ATTEMPT_FEEDBACK_RED = '#c64839'

export const AttemptProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  width: 100%;
`

export const AttemptProgressTrack = styled.div`
  flex: 1;
  min-width: 0;
  height: 10px;
  border-radius: 4px;
  background: #e7e7e7;
  overflow: hidden;
`

export const AttemptProgressFill = styled.div<{ $pct: number; $fill: string }>`
  width: ${(p) => p.$pct}%;
  height: 100%;
  background: ${(p) => p.$fill};
`

export const AttemptProgressSummary = styled.div`
  flex-shrink: 0;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  white-space: nowrap;

  @media ${MEDIA.MOBILE} {
    font-size: 11px;
    line-height: 13px;
  }
`

export type TestAttemptProgressFillTone = 'success' | 'danger'

type Props = {
  fillPercent: number
  summary: ReactNode
  fillTone?: TestAttemptProgressFillTone
}

export const TestAttemptProgressBar: FC<Props> = ({
  fillPercent,
  summary,
  fillTone = 'success'
}) => {
  const pct = Math.min(100, Math.max(0, fillPercent))
  const fillColor =
    fillTone === 'danger' ? TEST_ATTEMPT_FEEDBACK_RED : TEST_ATTEMPT_FEEDBACK_GREEN
  return (
    <AttemptProgressRow>
      <AttemptProgressTrack>
        <AttemptProgressFill $pct={pct} $fill={fillColor} />
      </AttemptProgressTrack>
      <AttemptProgressSummary>{summary}</AttemptProgressSummary>
    </AttemptProgressRow>
  )
}
import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { MEDIA } from '@brg/ui'

export const TEST_ATTEMPT_FEEDBACK_GREEN = '#29894e'
export const TEST_ATTEMPT_FEEDBACK_RED = '#c64839'

export const AttemptProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  width: 100%;
`

export const AttemptProgressTrack = styled.div`
  flex: 1;
  min-width: 0;
  height: 10px;
  border-radius: 4px;
  background: #e7e7e7;
  overflow: hidden;
`

export const AttemptProgressFill = styled.div<{ $pct: number; $fill: string }>`
  width: ${(p) => p.$pct}%;
  height: 100%;
  background: ${(p) => p.$fill};
`

export const AttemptProgressSummary = styled.div`
  flex-shrink: 0;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  white-space: nowrap;

  @media ${MEDIA.MOBILE} {
    font-size: 11px;
    line-height: 13px;
  }
`

export type TestAttemptProgressFillTone = 'success' | 'danger'

type Props = {
  fillPercent: number
  summary: ReactNode
  fillTone?: TestAttemptProgressFillTone
}

export const TestAttemptProgressBar: FC<Props> = ({
  fillPercent,
  summary,
  fillTone = 'success'
}) => {
  const pct = Math.min(100, Math.max(0, fillPercent))
  const fillColor =
    fillTone === 'danger' ? TEST_ATTEMPT_FEEDBACK_RED : TEST_ATTEMPT_FEEDBACK_GREEN
  return (
    <AttemptProgressRow>
      <AttemptProgressTrack>
        <AttemptProgressFill $pct={pct} $fill={fillColor} />
      </AttemptProgressTrack>
      <AttemptProgressSummary>{summary}</AttemptProgressSummary>
    </AttemptProgressRow>
  )
}
